export const pricesLabel = "Spirit Pass variants";
export const prices = [
  { price: 4950, label: "WEEKEND" },
  { price: 2750, label: "fridaySATURDAY" },
  { price: 2750, label: "fridaySUNDAY" },
];
